import React, { useState } from 'react'
import { makeStyles, createStyles } from '@material-ui/core'
import { DATE_FORMAT } from 'src/utils/constant'
import format from 'date-fns/format'
import { DayPicker as DayPicker2 } from 'react-day-picker'
import { zhCN, enGB } from 'date-fns/locale'
import 'react-day-picker/dist/style.css'
import { useTranslation } from 'react-i18next'

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      '& .rdp-months': {
        justifyContent: 'center',
      },
      '& .rdp-day': {
        color: '#fff',
        backgroundColor: theme.palette.primary.main,
        borderRadius: theme.spacing(4),
        margin: theme.spacing(0.25),
      },
      '& .rdp-button:hover:not([disabled]):not(.rdp-day_selected)': {
        backgroundColor: theme.palette.secondary.main,
      },
    },
  }),
)

const DatePicker = ({ avlDays, selectedDay, onChange, isMobile }) => {
  const classes = useStyles()
  const { i18n } = useTranslation()

  const [selected, setSelected] = useState(null)

  const isDateDisabled = (date) => {
    return !avlDays.some((item) => item.day === format(date, DATE_FORMAT))
  }
  const handleDayClick = (date) => {
    if (!isDateDisabled(date)) {
      setSelected(date)
      onChange?.(format(date, DATE_FORMAT))
    }
  }

  return (
    <DayPicker2
      mode="single"
      locale={i18n.language === 'en' ? enGB : zhCN}
      selected={selected}
      numberOfMonths={isMobile ? 1 : 2}
      onDayClick={handleDayClick}
      disabled={isDateDisabled}
      className={classes.root}
      modifiersStyles={{
        disabled: { opacity: 1, color: '#000', backgroundColor: '#fff' },
      }}
    />
  )
}

export default DatePicker
